<template>
	<section id="toponymMap" class="bg-white will-change h-[67vh] relative z-[1]" :data-scroll-section="inner == 'false'">

		<div class="flex items-center " :class="{'rounded-full topo-img overflow-hidden': activePoint.select === 'Toponym'}" ref="popup">
			<img v-if="activePoint.select === 'Toponym'" :src="activePoint.toponym[0].fields.image.sizes.thumbnail"	:alt="'toponym-img'" />
			<img v-if="activePoint.select === 'Other'" :src="activePoint.marker.url"	:alt="'toponym-img'" />
		</div>

		<div class="mx-content h-full">
			<!-- map -->
			<div id="map" class="topo-map rounded-lg" style="height: 100%;"></div>
			<!-- map -->
		</div>

		<!-- Slide Toponym card -->
        <div :class="{'xyz-in z-[51] active-card' : showToponymCard, 'xyz-out z-[40]' : !showToponymCard }"
                class="card-toponyms--slide fixed right-0 top-0 bottom-0 z-[51] flex flex-col bg-white shadow-md w-full sm:w-[504px] h-[calc(100vh-66px)] xl:h-[calc(100vh-116px)] overflow-y-auto invisible scroll-just-this"  
				xyz="fade right-100% duration-4" ref="toponymCard" data-scroll data-scroll-sticky data-scroll-target="#toponymMap"
				v-on-clickaway="clickAwaySlide">
            <button type="button" @click="showHideToponymCard()" class="grid place-items-center bg-mid-grey rounded-full cursor-pointer hover:opacity-70 w-10 h-10 absolute right-6 top-6">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="white"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M6 18L18 6M6 6l12 12" /></svg>
            </button>
            <div class="pb-10 h-full" v-if="activePoint.select === 'Toponym'">
                <div class="overflow-hidden h-[34vh]">
                    <img class="object-cover w-full" :src="activePoint.select === 'Toponym' ? activePoint.toponym[0].fields.image.url : activePoint.marker.url" :alt="'alt'">
                </div>
                <div class="p-8">
                    <h4 class="text-2xl tracking-[1px] mb-6" >{{ activePoint.select === 'Toponym' ? activePoint.toponym[0].post_title : activePoint.marker.name}}</h4>
                    <div class="text-sm" v-html="activePoint.select === 'Toponym' ? activePoint.toponym[0].fields.text : ''"></div>
                </div>
                <div v-show="activePoint.toponym[0].fields.gallery" class="toponym-swiper swiper-container h-[25vh]" ref="sliderModal">
                    <div class="swiper-wrapper">
                        <div v-for="( slide, index ) in activePoint.toponym[0].fields.gallery" :key="index" class="swiper-slide" >
                            <img class="object-cover w-full h-full" :src="slide.sizes.toponymslide" :alt="slide.alt">
                        </div>
                    </div>
                </div>
            </div>

        </div>

		<div class="absolute bottom-8 left-1/2 -translate-x-1/2 bg-white bg-opacity-90 rounded text-xs text-center px-10 py-5 whitespace-nowrap">
			<!-- <span v-if="!isMobile">{{ __('Hover over interest point for more info', 'ccave') }}</span> -->
			<span>{{ __('Click on the interest point or zoom in to view more', 'ccave') }}</span>
		</div>

	</section>
</template>

<script>
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css"
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import { mixin as clickaway } from 'vue-clickaway'
export default {
	name: "ToponymsMap",
	mixins: [ clickaway ],
	data() {
		return {
			activePoint: false,
			showToponymCard: false,
			toponymCategories: false,
			map: false,
			popup: false,

			/* MODAL SLIDER */
            sliderModal: null,
            sliderModalOptions: {
                    slidesPerView: 2,
                    spaceBetween: 16,
                    freeMode: true
            },
		};
	},
	mounted() {
		this.getToponymCategories()
		window.showHideToponymCard = this.showHideToponymCard

		mapboxgl.accessToken = this.blockData.map.map_settings.access_token;
		this.map = new mapboxgl.Map({
			container: "map", // container ID
			/* style: this.blockData.map.map_settings.style, */ // style URL
			style: 'mapbox://styles/aleksandarstojsin/ckxrfc6x570hh14pejpm0wfa5',
			center: this.blockData.map.map_settings.center, // starting position
			zoom: this.blockData.map.map_settings.zoom, // starting zoom
			pitch: this.blockData.map.map_settings.pitch,
			bearing: this.blockData.map.map_settings.bearing,
			cooperativeGestures: true,
            attributionControl: false
		});


		this.map.scrollZoom.disable();
		this.map.dragRotate.disable()
		this.map.touchZoomRotate.disableRotation()
		this.map.addControl(new mapboxgl.NavigationControl());


		this.map.on("load", () => {
			this.addDataLayer()
		})


		this.popup = new mapboxgl.Popup({
			closeButton: false,
			closeOnClick: false,
			/* offset: [0, -15] */
		});

		/* this.$refs.toponymCard.addEventListener('mouseenter', (e) => {
			this.$root.scroll.stop()
		})
		this.$refs.toponymCard.addEventListener('mouseleave', (e) => {
			this.$root.scroll.start()
		}) */
	},
	watch: {
		showToponymCard: function (val) {	if( val ) { this.$root.scroll.stop() } else { this.$root.scroll.start()	} }
	},
	methods: {
		clickAwaySlide() {
			this.showToponymCard = false
		},
		getToponymCategories() {
			this.$http.get( this.endpoints.rest_base_endpoint  + 'wp/v2/toponym_category' )
				.then( res => {
					this.toponymCategories = res.data

					//Add toponym markers to map image list
					this.toponymCategories.forEach(cat => {		
						this.map.loadImage(cat.data.fields.marker.url, (error, image) => {
							if (error) throw error;
							this.map.addImage( cat.id, image);
						})
					})
				}
			);
        },
		addDataLayer() {
			let clusterData = {
				type: 'ClusterData',
				crs: {},
				features: []
			}

			this.blockData.map.markers.forEach((marker, index) => {
				let mapData = JSON.parse(marker.map_data);
					mapData.properties = marker
					clusterData.features.push(mapData)
			});

			// Cluster data
			this.map.addSource('toponyms', {
				type: 'geojson',
				data: clusterData,
				cluster: true,
				clusterMaxZoom: 30, // Max zoom to cluster points on
				clusterRadius: 80 // Radius of each cluster when clustering points (defaults to 50)
			});
			// Cluster style 
			this.map.addLayer({
				id: 'clusters',
				type: 'circle',
				source: 'toponyms',
				filter: ['has', 'point_count'],
				paint: {
				// Use step expressions (https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-step)
				// with three steps to implement three types of circles:
				//   * Blue, 20px circles when point count is less than 100
				//   * Yellow, 30px circles when point count is between 100 and 750
				//   * Pink, 40px circles when point count is greater than or equal to 750
				'circle-color': [
					'step',
					['get', 'point_count'],
					'#FFFFFF',
					100,
					'#FFFFFF',
					750,
					'#FFFFFF'
				],
				'circle-radius': [
					'step',
					['get', 'point_count'],
					20,
					100,
					30,
					750,
					40
				]
				}
			})
			// Cluster count number
			this.map.addLayer({
				id: 'cluster-count',
				type: 'symbol',
				source: 'toponyms',
				filter: ['has', 'point_count'],
				layout: {
				'text-field': '{point_count_abbreviated}',
				'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
				'text-size': 12
				}
			})
			// Unclustered items
			this.map.addLayer({
				id: 'unclustered-point',
				type: 'symbol',
				source: 'toponyms',
				filter: ['!', ['has', 'point_count']],
				layout: {
 					"icon-image":  [ 'get', 'term_id', [ 'at', 0, [ 'get', 'toponym_categories', [ 'at', 0, [ 'get', 'toponym' ] ] ] ] ],
					"icon-anchor": "bottom",
					"icon-allow-overlap": true, 
					"text-field": [ 'get', 'post_title', [ 'at', 0, [ 'get', 'toponym' ] ] ] ,
					"text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
					"text-anchor": "top",
					"text-allow-overlap": true
				},
				paint: {
					"text-color": "black",
				}
			})

			this.map.on('click', 'clusters', (e) => {
				const features = this.map.queryRenderedFeatures(e.point, {
					layers: ['clusters']
				})
				const clusterId = features[0].properties.cluster_id
				this.map.getSource('toponyms').getClusterExpansionZoom(
					clusterId,
					(err, zoom) => {
						if (err) return;
					
						this.map.easeTo({
							center: features[0].geometry.coordinates,
							zoom: zoom
						})
					}
				)
			})

			this.map.on('click', 'unclustered-point', (e) => {
				e.originalEvent.preventDefault()
				e.originalEvent.stopPropagation()
				e.features[0].properties.toponym = JSON.parse(e.features[0].properties.toponym)
				if (e.features[0].properties.select === 'Toponym') {
					this.showHideToponymCard(e.features[0].properties)
				}
			});

			this.map.on("mousemove", 'unclustered-point', e => {
				e.features[0].properties.toponym = JSON.parse(e.features[0].properties.toponym)
				this.activePoint = e.features[0].properties
				if (e.features[0].properties.select === 'Other') {
					this.showToponymCard = false
				}
				this.popup
					.setLngLat(e.lngLat)
					.setDOMContent(this.$refs.popup)
					.addTo(this.map);
			});

			this.map.on("mouseleave", 'unclustered-point', () => {
				if (!this.showToponymCard) {
					this.activePoint = false
				}
				this.popup.remove()
			})

			this.map.on('mouseenter', 'clusters', () => {
				this.map.getCanvas().style.cursor = 'pointer';
			});
			this.map.on('mouseleave', 'clusters', () => {
				this.map.getCanvas().style.cursor = '';
			});
			this.map.on('mouseenter', 'unclustered-point', () => {
				this.map.getCanvas().style.cursor = 'pointer';
			});
			this.map.on('mouseleave', 'unclustered-point', () => {
				this.map.getCanvas().style.cursor = '';
			});

		},
		showHideToponymCard(toponym){
                if ( this.$refs.toponymCard.classList.contains('invisible') && !this.showToponymCard ) {
                    this.$refs.toponymCard.style.visibility = 'visible'
                    this.activePoint = toponym
                    this.showToponymCard = true

                   this.$nextTick( ()=>{ this.sliderModal = new Swiper( this.$refs.sliderModal, this.sliderModalOptions ) } )
				   
				   let offsetCard
					if ( this.$root.isMobile ){
						offsetCard = -67 
					} else{
						offsetCard = -116 
					}

					this.$root.scroll.scrollTo('#toponymMap', {
						offset: offsetCard,
						duration: 800,
						disableLerp: true
					})

                } else  {
                    setTimeout(() => {
                        this.$refs.toponymCard.style.visibility = 'hidden'
                    }, 500);
                    this.showToponymCard = false
                }
            },
	},
};
</script>

<style scoped>
.map {
	position: absolute;
	left: 33.3333%;
	width: 66.6666%;
	top: 0;
	bottom: 0;
}

</style>

